module.exports = __webpack_public_path__ + "img/Accessories_1200x800.e9aa6151.png";